import { request } from '../utils'
import { SEARCH_COMPANIES } from '../routes/api'

const buildQuery = ({ q, ids, page } = {}) => {
  const parts = []
  if (q) parts.push(`q=${encodeURIComponent(q)}`)
  if (Array.isArray(ids) && ids.length) ids.forEach((id) => parts.push(`ids[]=${encodeURIComponent(id)}`))
  if (page) parts.push(`page=${page}`)
  return parts.join('&')
}

class CompanyApi {
  static searchCompanies (options = {}, onSuccess, onError) {
    const { q, ids, page, ...rest } = options
    return request({ url: SEARCH_COMPANIES(buildQuery({ q, ids, page })), method: 'get', ...rest }, onSuccess, onError)
  }
}

export default CompanyApi
